import SeoPage from "../components/SeoPage";

export default function MobileApp() {
  return (
    <SeoPage
      title="Mobile App Development Company | Arviko"
      description="Top mobile app development company building Android and iOS apps."
      heading="Mobile App Development Company"
    >
      <p>
        We develop high-quality Android and iOS applications with modern technologies.
      </p>
    </SeoPage>
  );
}